import classNames from 'classnames';
import React from 'react';
import styles from '../Form.module.scss';
import { Props as InputProps } from 'components/core/Input/Input';

type DefaultProps = React.DetailedHTMLProps<
  React.LabelHTMLAttributes<HTMLLabelElement>,
  HTMLLabelElement
>;

type FormLabelProps = DefaultProps & {
  isVisuallyHidden?: boolean;
  isBold?: boolean;
  size?: InputProps['size'];
};

export const FormLabel = ({
  children,
  className,
  isVisuallyHidden = false,
  isBold = false,
  size = 'sm',
  ...props
}: FormLabelProps) => {
  return (
    <label
      {...props}
      className={classNames(className, styles.FormLabel, {
        [styles.visuallyHidden]: isVisuallyHidden,
        [styles.isBold]: isBold,
        [styles[size]]: size,
      })}
    >
      {children}
    </label>
  );
};
